/** API returns HashPassword; forms use Password label. */
export const getUserPasswordFromApi = (user) =>
  user?.HashPassword ??
  user?.hashPassword ??
  user?.Password ??
  user?.password ??
  '';

/** Format API date for <input type="date" />. */
export const formatDateForInput = (value) => {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return date.toISOString().slice(0, 10);
};

export const GENDER_OPTIONS = ['Male', 'Female', 'Other'];

/** Map GetById response into admin form state. */
export const mapUserFromApi = (user = {}) => ({
  FirstName: user.FirstName || '',
  LastName: user.LastName || '',
  Email: user.Email || '',
  Username: user.Username || '',
  Password: getUserPasswordFromApi(user),
  ConfirmPassword: '',
  MobileNumber: user.MobileNumber || user.Mobile || '',
  Gender: user.Gender || '',
  DateOfBirth: formatDateForInput(user.DateOfBirth),
  RoleId: user.RoleId || '',
  IsEmailVerified: !!user.IsEmailVerified,
  IsMobileVerified: !!user.IsMobileVerified,
  IsBlocked: !!user.IsBlocked,
});

/** Send password on create/update (API field names). */
export const buildUserPasswordPayload = (password) => {
  const value = String(password ?? '');
  return {
    Password: value,
    HashPassword: value,
  };
};

/** Build create/update payload matching User API parameters. */
export const buildUserSavePayload = (form, { userId } = {}) => {
  const payload = {
    FirstName: String(form.FirstName || '').trim(),
    LastName: String(form.LastName || '').trim() || null,
    Email: String(form.Email || '').trim(),
    Username: String(form.Username || '').trim(),
    MobileNumber: String(form.MobileNumber || '').trim() || null,
    Gender: String(form.Gender || '').trim() || null,
    DateOfBirth: form.DateOfBirth || null,
    IsEmailVerified: !!form.IsEmailVerified,
    IsMobileVerified: !!form.IsMobileVerified,
    IsBlocked: !!form.IsBlocked,
    RoleId: form.RoleId ? Number(form.RoleId) : null,
  };

  if (userId != null) {
    payload.UserId = Number(userId);
  }

  return payload;
};
